import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { LoadingDots } from "../Components/LoadingDots";
import accountService from "../Services/accountService";
import { FaArrowLeft } from "react-icons/fa6";
import SecondaryButton from "../Components/SecondaryButton";
import { FiPlus } from "react-icons/fi";

const AddAccount = () => {
  const navigate = useNavigate();
  const [responseError, setResponseError] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    account_name: "",
    account_title: "",
    account_number: "",
    opening_balance: "",
  });

  const [errors, setErrors] = useState({
    account_name: false,
    account_title: false,
    account_number: false,
    opening_balance: false,
  });

  const [regex, setRegex] = useState({
    account_name: /.{1,50}$/,
    account_title: /.{1,50}$/,
    account_number: /.{1,50}$/,
    opening_balance: /.{1,50}$/,
  });

  const handleChange = (v, n) => {
    setResponseError("");
    if (n === "opening_balance" && v < 0) {
      return;
    }
    setData((d) => ({ ...d, [n]: v }));
    if (v.length > 0) {
      setErrors((prevState) => ({ ...prevState, [n]: false }));
    }
  };

  const handleSubmit = () => {
    let hasError = false;
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill the form correctly", { id: "1" });
    } else {
      setLoading(true);
      let formData = {
        ...data,
        current_balance: data.opening_balance,
        status: "ACTIVE",
      };
      accountService.create(formData).then((res) => {
        setLoading(false);
        toast.success("Account Added Successfully", { id: "2" });
        navigate("/accounts");
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <main className="mx-10 mt-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <h1 className="font-bold text-3xl text-secondary text-center mt-10">
        Add Account
      </h1>

      <div className="mt-10 px-80">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-4">
          <div>
            <label className="primary-label">Account Name</label>
            <input
              value={data.account_name}
              name="account_name"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Account Name"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["account_name"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className="primary-label">Account Title</label>
            <input
              value={data.account_title}
              name="account_title"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Account Title"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["account_title"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className="primary-label">Account Number</label>
            <input
              value={data.account_number}
              name="account_number"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Account Number"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["account_number"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className="primary-label">Opening Balance</label>
            <input
              value={data.opening_balance}
              name="opening_balance"
              type="number"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Opening Balance"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["opening_blanance"]
                  ? "border-red-600"
                  : "border-gray-300"
              }`}
            />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center mt-12">
        <SecondaryButton
          text={loading ? <LoadingDots /> : "Add"}
          Icon={FiPlus}
          color="!px-16"
          onClick={() => handleSubmit()}
        />
      </div>
    </main>
  );
};

export default AddAccount;
